import React, { useState, useEffect } from 'react'
import moment from 'moment-timezone';
import { PaymentMethod } from "@stripe/stripe-js";
import CancelIcon from '@mui/icons-material/Cancel';
import { ResourceSchema, ResourceType, ResourceBookingSchema  } from "../../data/types";
import { foodBusinessCategories } from '../../utils/enums';
import { capitalizeString } from '../../utils/helpers';
import { useCompleteSignIn, useLoadUserResourceBooking } from '../../hooks/authhooks';
import { useGetPaymentMethods } from '../../hooks/paymenthooks';
// import StripePaymentCheckOut from "./PaymentCheckOut";
import BookingPaymentsView from "../../components/Mobile/BookingPaymentsView";
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CheckMarkIcon } from "../../icons/CheckMarkIcon.svg";
import SubmitRequestButton from '../../components/SubmitRequestButton';




  type ObtainDocumentationFormProps = {
    resourceDetail: ResourceSchema
    handleClose: () => void;
    handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean> | boolean | void
};
  
const ObtainDocumentationForm: React.FC<ObtainDocumentationFormProps> = (props) => {
    var { resourceDetail, handleSubmitRequest, handleClose } = props;
    const navigate = useNavigate();
    const [application, setApplication] = useState<ResourceBookingSchema>({} as ResourceBookingSchema);
    const [businessCategory, setBusinessCategory] = useState<number>(0);
    const [businessTypes, setBusinessTypes] = useState<string[]>(foodBusinessCategories[businessCategory].types);
    const [businessType, setbusinessType] = useState<string>(businessTypes[0]);

    const { user } = useCompleteSignIn();
    const loggedinUid = (user && user?.uid) ? user.uid : ''
    const { userResourceBooking } = useLoadUserResourceBooking(resourceDetail?.community_id || "", resourceDetail?.id || "", loggedinUid);
    var { paymentMethods } = useGetPaymentMethods(loggedinUid)

    paymentMethods = (paymentMethods && Array.isArray(paymentMethods)) ? paymentMethods : [];
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(
      (paymentMethods && paymentMethods.length > 0) ? paymentMethods[0] : {} as PaymentMethod
    );
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target;
      if (name && value) {
        setApplication((prev => ({
          ...prev,
          [name]: value
        })));
      }

      if (name === 'payment_method' && value){
        const selectedMethod = paymentMethods.find((pm:any) => pm.id === value);
        setPaymentMethod(selectedMethod);
      }
    };

    const selectBusinessCategories = (e: React.ChangeEvent<HTMLSelectElement>) => {
      e.preventDefault()
      const {name, value} = e.target
      if (name === 'category' && value){
        const categoryIndex = parseInt(value)
        const categoryObject = foodBusinessCategories[categoryIndex]
        setBusinessCategory(categoryIndex)
        setApplication((prev => ({
          ...prev,
          business_category: categoryObject.category,
        })));
        setBusinessTypes(categoryObject.types)
      } else if (name === 'business_type' && value){
        setbusinessType(value)
        setApplication((prev => ({
          ...prev,
          business_type: value,
        })));
      }
      
    }
  
    const handleSubmit = async () => {
      if (isSubmitting || !(application && resourceDetail && resourceDetail.resource_type)) return;
      const total_cost = resourceDetail.total_amount ? resourceDetail.total_amount : 0
      application.total_cost = total_cost
      setIsSubmitting(true);
      try {
        await handleSubmitRequest(resourceDetail, resourceDetail.resource_type, application);
        handleClose();
        navigate('/bookings');
      } finally {
        setIsSubmitting(false);
      }
    };


    useEffect(() => {
      setPaymentMethod((paymentMethods && paymentMethods.length > 0) ? paymentMethods[0] : {} as PaymentMethod)  
      // eslint-disable-next-line 
    }, [resourceDetail, resourceDetail.community_id])
  
    return (
      <div className="flex flex-col justify-start items-center h-full min-h-0">
        <span onClick={handleClose} className="ml-auto w-full flex cursor-pointer mb-2">
            <CancelIcon className="text-[#A1A1A1] hover:text-[#777] h-[20px] w-[20px] ml-auto" />
        </span>

        <div className='h-[4px] border-0 bg-primaryDark-400 w-full my-4' />
        
        {(userResourceBooking && userResourceBooking?.status && userResourceBooking?.status !== 'canceled') ? (
          <div className="flex flex-col items-center justify-center w-full py-8">
            <div className="w-16 h-16 mb-6 rounded-full bg-primaryDark-400 flex items-center justify-center">
              <CheckMarkIcon className="w-8 h-8 text-white" />
            </div>
            <h2 className='text-black font-semibold text-[20px] sm:text-[24px] font-raleway text-center mb-2'>
              Request Already Submitted
            </h2>
            <p className='text-[#4D4D4D] text-[14px] sm:text-[16px] font-open-sans text-center mb-6 max-w-md px-4'>
              You have already submitted a request for <span className='font-semibold'>{resourceDetail.name}</span> on <span className='font-semibold'>{moment(userResourceBooking?.created).format('MMM DD, YYYY')}</span>. Please check your bookings for status updates.
            </p>
            <button
              onClick={() => {
                handleClose();
                navigate('/bookings');
              }}
              className="py-3 px-8 font-semibold text-[16px] sm:text-[18px] font-raleway border-0 bg-primaryDark-0 text-white rounded-lg hover:bg-primaryDark-300 transition-colors touch-manipulation"
            >
              View My Bookings
            </button>
          </div>
        ) : (
          <>
            <p className='text-black font-semibold text-[20px] sm:text-[24px] font-raleway text-left w-full mb-1'>
            Obtain your <span className='font-bold'>{resourceDetail.name}</span>
            </p>
            <p className="text-left text-[14px] sm:text-[16px] my-2 font-open-sans font-normal text-[#4D4D4D] w-full mb-4">Fill out the details below to obtain documentation for your business.</p>

            <div className='border-[1px] border-[#E9E9E9] p-4 sm:p-6 rounded-lg w-full bg-white'>
          <div className="flex flex-col w-full mb-4">
              <label className='text-black font-semibold text-[15px] sm:text-[16px] font-raleway text-left mb-2'>
                Business Category
              </label>
              <div className='border-[#E9E9E9] border-[1px] rounded-lg'>
                  <select
                      className="formInput w-full h-[52px] sm:h-[59px] bg-inherit px-4 py-3 border-0 text-[15px] sm:text-[16px] font-open-sans text-[#333333]"
                      name="category"
                      value={businessCategory}
                      onChange={e => {
                        selectBusinessCategories(e)
                      }}
    
                  >

                    {
                      foodBusinessCategories.map((data: any, i: number)=>
                        (
                          <option value={i} key={i}>
                              {data.category}
                          </option>
                        )
                      )
                    }
                  </select>
              </div>
          </div>

          <div className="flex flex-col w-full mb-4">
              <label className='text-black font-semibold text-[15px] sm:text-[16px] font-raleway text-left mb-2'>
                Type of Business
              </label>
              <div className='border-[#E9E9E9] border-[1px] rounded-lg'>
                  <select
                      className="formInput w-full h-[52px] sm:h-[59px] bg-inherit px-4 py-3 border-0 text-[15px] sm:text-[16px] font-open-sans text-[#333333]"
                      name="business_type"
                      value={businessType}
                      onChange={selectBusinessCategories}
                  >

                    {
                      businessTypes.map((type: any, i: number)=>
                      (
                        <option value={type} key={i}>
                            {type}
                        </option>
                      ))
                    }
                  </select>
              </div>
          </div>

          <div className="flex flex-col w-full mb-4">
              <label className='text-black font-semibold text-[15px] sm:text-[16px] font-raleway text-left mb-2'>
                Business Name
              </label>
              <div className='border-[#E9E9E9] border-[1px] rounded-lg'>
                  <input
                      type="text"
                      placeholder="Business Name"
                      className="formInput w-full h-[52px] sm:h-[59px] bg-inherit px-4 py-3 border-0 text-[15px] sm:text-[16px] font-open-sans text-[#333333] placeholder-[#999999]"
                      name="business_name"
                      value={application?.business_name || ''}
                      onChange={handleInputChange}
                  />
              </div>
          </div>


          <div className="flex flex-col w-full mb-4">
              <label className='text-black font-semibold text-[15px] sm:text-[16px] font-raleway text-left mb-2'>
                Address
              </label>
              <div className='border-[#E9E9E9] border-[1px] rounded-lg'>
                  <input
                      type="text"
                      placeholder="Business Address"
                      className="formInput w-full h-[52px] sm:h-[59px] bg-inherit px-4 py-3 border-0 text-[15px] sm:text-[16px] font-open-sans text-[#333333] placeholder-[#999999]"
                      name="location"
                      value={application?.location || ''}
                      onChange={handleInputChange}
                  />
              </div>
          </div>

          {
            (resourceDetail?.total_amount) ? (
              <div className="flex flex-col w-full mb-4">
                  <label className='text-black font-semibold text-[15px] sm:text-[16px] font-raleway text-left mb-2'>
                    Payment Method
                  </label>

                  {(paymentMethods && paymentMethods.length > 0) && (<BookingPaymentsView paymentMethod={paymentMethod} handleSetApplication={handleInputChange} />)}
              </div>
            ) : (<></>)
          }

          <div className="flex flex-row items-center justify-between rounded-lg h-auto w-full my-4 pt-4 border-t border-[#E9E9E9] text-black font-semibold text-[15px] sm:text-[16px] font-raleway">
            <p>{resourceDetail?.resource_type ? capitalizeString(resourceDetail.resource_type) : 'Resource'} cost:</p>
            <p className='font-semibold ml-2'>${resourceDetail?.total_amount ? resourceDetail.total_amount.toFixed(2) : '0.00'}</p>
          </div>
        </div>

        <div className='flex flex-row gap-3 my-4 w-full'>
          <button
              className="flex-1 py-3 px-4 font-semibold text-[16px] sm:text-[18px] font-raleway text-primaryDark-0 bg-white border-[#E9E9E9] border-[1px] rounded-lg hover:bg-gray-50 transition-colors touch-manipulation"
              data-testid="cancel-button"
              onClick={handleClose}
            > 
                  Cancel  
          </button>
          <SubmitRequestButton
              isSubmitting={isSubmitting}
              disabled={(!businessCategory && businessCategory !== 0)|| !businessType || !application?.business_name || (!paymentMethod?.id && resourceDetail?.total_amount ? true : false)}
              onClick={handleSubmit}
              className={`flex-1 py-3 px-4 font-semibold text-[16px] sm:text-[18px] font-raleway border-0 rounded-lg transition-colors touch-manipulation text-white ${((!businessCategory && businessCategory !== 0) || !businessType || !application?.business_name ||(!paymentMethod?.id && resourceDetail?.total_amount ? true : false)) ? 'bg-gray-300 cursor-not-allowed' : 'bg-primaryDark-0 hover:bg-primaryDark-300'}`}
          />
        </div>
          </>
        )}
   
      </div>
    );
  };

  export default ObtainDocumentationForm

